module.exports = __webpack_public_path__ + "media/images/icon__burger-menu-1d60d54a41b19a9a2f267269d3e7becd.png";